export enum UserAccountType {
  ADMINISTRATOR = 'administrator',
  COORDINATOR = 'coordinator',
}

export enum EnumAgencyType {
  MAIN = 'main',
  SUBSTATION = 'substation',
}
